import NameFilter from "@/components/Filters/NameFilter";
import SearchSelect from "@/components/Filters/SearchSelect";
import { ColorFilterRB } from "@/components/Filters/ColorFilter";
import CostFilter from "@/components/Filters/CostFilter";
import PowerFilter from "@/components/Filters/PowerFilter";
import TypeFilter from "@/components/Filters/TypeFilter";
import ShowAAsFilter from "@/components/Filters/ShowAAsFilter";
import { Button } from "@heroui/react";

interface DeckCardsMap {
  [key: string]: {
    count: number;
    cards: string[];
  };
}

interface IFiltersRB {
  searchSelect: Set<string>;
  search: string;
  text: string;
  color: Set<string>;
  cost: Set<string>;
  powerCost: Set<string>;
  might: Set<string>;
  cardType: Set<string>;
  format: Set<string>;
  showAAs: boolean;
}

interface RBFiltersProps {
  filters: IFiltersRB;
  setFilter: (key: keyof IFiltersRB, value: any) => void;
  searchDisplay: string;
  setSearchDisplay: (value: string) => void;
  deckCardsMap: DeckCardsMap;
  clearAllFilters: () => void;
}

export default function RBFilters({
  filters,
  setFilter,
  searchDisplay,
  setSearchDisplay,
  deckCardsMap,
  clearAllFilters,
}: RBFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2 mt-2 mb-2 items-center">
      <div className="flex flex-row">
        <SearchSelect
          selected={filters.searchSelect}
          setSelected={(val: any) => setFilter("searchSelect", val)}
        />
        <NameFilter
          selected={searchDisplay}
          setSelected={setSearchDisplay}
          placeholder={"Search"}
          rounded="rounded-l-none"
        />
      </div>
      <ColorFilterRB
        selected={filters.color}
        setSelected={(val: any) => setFilter("color", val)}
      />
      <CostFilter
        selected={filters.cost}
        setSelected={(val: any) => setFilter("cost", val)}
      />
      <PowerFilter
        selected={filters.powerCost}
        setSelected={(val: any) => setFilter("powerCost", val)}
      />
      <TypeFilter
        selected={filters.cardType}
        setSelected={(val: any) => setFilter("cardType", val)}
      />
      <ShowAAsFilter
        selected={filters.showAAs}
        setSelected={(val: any) => setFilter("showAAs", val)}
      />
      <Button
        onPress={() => {
          clearAllFilters();
        }}
        size="sm"
        variant="ghost"
        color="primary"
      >
        Clear
      </Button>
    </div>
  );
}
